import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AgendaCard from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.themeTableDetail,
    narratives: state.narratives.list,
    speedDatingMeetings: state.speedDating.meetings,
  };
}

function mapDispatchToProps() {
  return {
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgendaCard));



// WEBPACK FOOTER //
// ./src/components/Cards/AgendaCard/container/index.js